<div class="p-5 prose" *transloco="let t">
 <h2 class="t-page-title text-2xl font-bold" [innerHTML]="t('help.title')"></h2>
   <div class="t-help-intro text-base" [innerHTML]="t('help.text.intro')"></div>
   <div class="t-help-howgenerated text-base" [innerHTML]="t('help.text.howgenerated', translationParams)"></div>
   <div class="t-help-formulategoodquestion text-base" [innerHTML]="t('help.text.formulategoodquestion')"></div>
   <div class="t-help-supportedquestions text-base" [innerHTML]="t('help.text.supportedquestions', translationParams)"></div>
   <div class="t-help-unsupportedquestions text-base" [innerHTML]="t('help.text.unsupportedquestions')"></div>
   <div class="t-help-shareyourthoughts text-base" [innerHTML]="t('help.text.shareyourthoughts')"></div>
</div>